export default "__VITE_ASSET__6598a92f__"